import type { TUser } from "~/app/components/Profile/type/TUser";
import { paymentsBackendDelegate } from "../payment/playgami";
import { Titan, tracker } from "./scopelyId";

type EventParameters = Record<string, unknown>;
const warm_start = localStorage.getItem("warm_start") as unknown;

export const trackEvent = (name: string, parameters: EventParameters = {}): void => {
  Titan.SendEvent({ name, parameters });
};

export const updateAnalyticsUser = (id: number, email?: string) => {
  tracker.getContext().setTenant(String(id || -7));
  paymentsBackendDelegate.setCurrentUserId(id.toString());
};

export const startupComplete = () => {
  let frameCount = 0;
  let animationFrameId: number;

  const trackFrames = () => {
    frameCount++;
    animationFrameId = requestAnimationFrame(trackFrames);
  };

  // Start counting frames as soon as possible
  animationFrameId = requestAnimationFrame(trackFrames);

  const perfObserver = new PerformanceObserver((observedEntries) => {
    const entries = observedEntries.getEntries();
    const pageLoadDuration = entries[0].duration / 1000;

    // Stop frame tracking once navigation is measured
    cancelAnimationFrame(animationFrameId);

    // console.warn('Analytics start_up_complete', parseFloat(pageLoadDuration.toFixed(2)));

    Titan.SendEvent({
      name: "startup_complete",
      parameters: {
        time_since_startup: Number.parseFloat(pageLoadDuration.toFixed(2)),
        frame_count: frameCount,
      },
    });
  });

  perfObserver.observe({ type: "navigation", buffered: true });
};

export const appOpen = (diamondsBalance?: string | number, userData?: TUser) => {
  const login_type = localStorage.getItem("login_type");
  const authStorage = JSON.parse(localStorage.getItem("auth-storage") || "{}");

  Titan.SendEvent({
    name: "sys.app_open",
    parameters: {
      is_warm_start: +Number(warm_start) ? false : true,
      sys_platform: "web",
      event_source: "web_portal",
      facebookconnected:
        !!(authStorage?.state?.user?.HasConnectedFacebook || login_type?.toLowerCase().includes("facebook")),
      newuser: authStorage?.state?.user?.FirstLoginForGame,
      diamonds_balance: diamondsBalance,
      friends: userData?.Data?.NumFriends
    },
  });
  localStorage.setItem("warm_start", String(+Number(warm_start) + 1));
};
